<template>
  <v-container>
    <v-dialog v-model="dialog" max-width="400px" persistent>
      <v-card>
        <v-card-title>
          <span class="headline">{{ tituloModal }}</span>
          <v-spacer></v-spacer>
          <v-btn color="grey lighten-1" text @click="cerrarModal">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <!-- contenido -->
        <ValidationObserver ref="form_datos">
          <v-card class="mx-auto">
            <v-card-text class="text--primary px-8">
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <ValidationProvider name="Nombre" rules="required">
                    <v-text-field
                      type="text"
                      v-model="objDatos.nombre"
                      label="Nombre"
                      slot-scope="{ errors, valid }"
                      :error-messages="errors"
                      :success="valid"
                    ></v-text-field>
                  </ValidationProvider>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </ValidationObserver>

        <!-- fin contenido -->
        <v-card-actions class="pb-8 pl-8">
          <v-btn @click="save" color="primary" dark> Guardar </v-btn>
          <v-btn color="warning" dark @click="cerrarModal"> Cancelar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { db } from "../../firebase";
export default {
  name: "ModalArea",
  data: () => ({
    objDatos: {},
    dialog: true,
    collection: "area",
  }),
  props: {
    showModal: { type: Boolean, default: false },
    id: { type: String },
  },
  computed: {
    tituloModal(props) {
      return props.id ? "ACTUALIZAR" : "AGREGAR";
    },
  },
  async created() {
    await this.getData();
  },
  methods: {
    async getData() {
      try {
        if (this.id) {
          const datos = await db.collection(this.collection).doc(this.id).get();
          this.objDatos = datos.data();
        }
      } catch (error) {
        this.handleError(error);
      }
    },
    async save() {
      try {
        if (!this.id) {
          // Guardar
          const validar = await this.$refs.form_datos.validate();
          if (!validar) return false;
          this.objDatos.creado = Date.now();
          this.objDatos.estado = true;
          this.objDatos.nombre = this.objDatos.nombre.toUpperCase().trim();
          await db.collection(this.collection).add(this.objDatos);
          this.$swal({
            icon: "success",
            title: "Operación Exitosa",
            text: "",
          });
          this.cerrarModal();
          this.$emit("actualizar");
        } else {
          // Actualizar
          this.objDatos.creado = Date.now();
          await db
            .collection(this.collection)
            .doc(this.id)
            .update(this.objDatos);
          this.$swal({ icon: "success", title: "Operación Exitosa", text: "" });
          this.cerrarModal();
          this.$emit("actualizar");
        }
      } catch (error) {
        this.handleError(error);
      }
    },
    cerrarModal() {
      this.$emit("update:showModal", !this.showModal);
      this.objDatos = {};
    },
    handleError({ message }) {
      this.$swal({ icon: "error", title: "Oops...", text: message });
      this.loading = false;
    },
  },
};
</script>
